/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Qrmarginwide2Inputs */

const en_qrmarginwide2 = /** @type {(inputs: Qrmarginwide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wide`)
};

const de_qrmarginwide2 = /** @type {(inputs: Qrmarginwide2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Breit`)
};

/**
* | output |
* | --- |
* | "Wide" |
*
* @param {Qrmarginwide2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const qrmarginwide2 = /** @type {((inputs?: Qrmarginwide2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Qrmarginwide2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_qrmarginwide2(inputs)
	return de_qrmarginwide2(inputs)
});
export { qrmarginwide2 as "qrMarginWide" }